export type NodeType = 'consultant' | 'grower' | 'other' | 'rv';

export type NodeScopeContext = 'myFields' | 'growers' | 'rvs';

export interface NodeScopeFilters {
    includeChildren: boolean;
    excludeTargetNode: boolean;
    nodeType?: NodeType;
}

// Resolves the node-tree scoping filters for a given page context.
// - myFields: the user's own node only.
// - growers: the node's children growers, excluding the node's own "My Fields" data.
// - rvs: the node's children, restricted to grower-type nodes (so RVs' own
//   "My Fields" data is not included; nodeType makes excludeTargetNode unnecessary).
export const getNodeScopeFilters = (context: NodeScopeContext): NodeScopeFilters => {
    switch (context) {
        case 'myFields':
            return { includeChildren: false, excludeTargetNode: false };
        case 'growers':
            return { includeChildren: true, excludeTargetNode: true };
        case 'rvs':
            return { includeChildren: true, excludeTargetNode: false, nodeType: 'grower' };
    }
};
